// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"4822a288","445":"c4e2fa82"}[chunkId] + ".css";
};